import dayjs from "dayjs";
import moment from "moment";
import { dateFormat, dbDateFormat } from "../../../constants/constants";
import { useGetLeaveAdjustmentLogQuery } from "../../../features/leaveProrate/leaveProrateApi";
import useError from "../../../hooks/useError";
import { underscoreToCapitalizeString } from "../../../utils/utils";
import Loader from "../../ui/Loader";

type Props = {
  businessMemberId?: string | number;
  leaveTypeId?: string | number;
  className?: string;
};

export default function AdjustmentLog({
  businessMemberId,
  leaveTypeId,
  className = "",
}: Props) {
  // console.log(leaveTypeId);
  const {
    isLoading: isAdjustmentLoading,
    isError: isAdjustmentError,
    error: adjustmentError,
    data: adjustmentData,
  } = useGetLeaveAdjustmentLogQuery({
    params: {
      business_member_id: Number(businessMemberId),
      leave_type_id: leaveTypeId ? Number(leaveTypeId) : undefined,
    },
  });
  useError(isAdjustmentError, adjustmentError, "Get leave adjustment log fail");

  if (isAdjustmentLoading) {
    return <Loader />;
  }

  return (
    <div className={`max-h-[400px] overflow-y-auto ${className}`}>
      {adjustmentData?.data?.logs?.map((item) => {
        const rule = item?.rule_applied;
        const penaltyAmount = Number(rule?.penalty_amount);

        return (
          <div
            className="flex items-center py-4 first:pt-0 last:pb-0 border-b border-extra-light last:border-b-0"
            key={item?.id}
          >
            <div className="w-9">
              <span className="w-2.5 h-2.5 bg-complete rounded-full block" />
            </div>
            <div className="flex-1">
              <h6 className="text-tint-neutral text-sm font-semibold mb-[3px]">
                {dayjs(item?.created_at)?.format(dateFormat)}
              </h6>

              <p className="text-display-body leading-7 flex item-center gap-1.5">
                <span className="text-header font-medium">Policy Type:</span>{" "}
                {underscoreToCapitalizeString(
                  rule?.policy_type === "late_checkin_early_checkout"
                    ? "Late Attendance"
                    : rule?.policy_type
                )}
              </p>

              <p className="text-display-body leading-7 flex item-center gap-1.5">
                <span className="text-header font-medium"> Rule:</span> from{" "}
                {rule?.from_days} {rule?.from_days > 1 ? "days" : "day"} to{" "}
                {rule?.to_days} {rule?.to_days > 1 ? "days" : "day"} penalty is{" "}
                {rule?.penalty_type_name} , Amount: {penaltyAmount}{" "}
                {penaltyAmount > 1 ? "days" : "day"}
              </p>
              <p className="text-display-body leading-7  item-center gap-1.5">
                <span className="text-header font-medium">
                  {" "}
                  Adjustment Reason:{" "}
                </span>
                {item?.adjustment_reason}
              </p>
              <p className="text-display-body leading-7  item-center gap-1.5">
                <span className="text-header font-medium">
                  {" "}
                  Adjustment Month:{" "}
                </span>
                {item?.adjustment_month
                  ? moment(item?.adjustment_month, dbDateFormat).format(
                      "MMMM, YYYY"
                    )
                  : "-"}
              </p>
              <p className="text-display-body leading-7 inline-flex item-center gap-1.5">
                <span className="text-header font-medium">
                  Adjusted Amount:
                </span>{" "}
                {item?.adjustment_amount}{" "}
                {item?.adjustment_amount > 1 ? "days" : "day"}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
